import apiCall from "./apiCall";

/**
 * The main dashboard's data.
 *
 * One request rather than a dozen: the page used to fire a call per figure,
 * which meant a dozen round trips to render four numbers. Accounting is not in
 * here — it has a dashboard of its own, built on its own figures.
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async getOverview(data = {}) {
    return await apiCall("dashboard/overview", data);
  },
};
